/**
 * Controller: ReportsCreateShowMultiselectModal
 */
angular.module('acme.view.application.reports.create.showMultiselectModal.controllers', [])
.controller('ReportsCreateShowMultiselectModalController', [ '$scope', '$uibModalInstance', 'filter', 'currentValues', function ($scope, $uibModalInstance, filter, currentValues) {

    $scope.errors = [];

    $scope.model = [];
    $scope.filter = [];
    $scope.selected = {};
    $scope.selectedCount = 0;

    $scope.init = function() {
      $scope.filter = angular.copy(filter);
      $scope.model = angular.copy(currentValues);
      $scope.cache = angular.copy(currentValues);
      $scope.selected = {};
      $scope.toggleSelected();
      console.log('ReportsCreateShowMultiselectModalController', $scope.model);
    };

    $scope.toggleColumn = function(value) {
      $scope.selected[value] = !$scope.selected[value];

      console.log('ReportsCreateShowMultiselectModalController::toggleColumn', $scope.selected);
      if ($scope.selected[value]) {
        $scope.selectedCount++;
      }else{
        $scope.selectedCount--;
      }
    };

    $scope.toggleSelected = function() {
      var i, ii,
          values = ($scope.filter.fieldValue) ? $scope.filter.fieldValue.split(',') : [];

      $scope.selectedCount = 0;
      console.log('ReportsCreateShowMultiselectModalController::toggleSelected', values, $scope.filter.fieldValue);

      for (i=0,ii=values.length;i<ii;i++) {
        $scope.selected[values[i]] = true;
        $scope.selectedCount++;
      }

      console.log('ReportsCreateShowMultiselectModalController::toggleSelected', $scope.selected);

    };

    $scope.countSelected = function() {

      var field;

      $scope.selectedCount = 0;

      for (field in $scope.selected) {
        if ($scope.selected.hasOwnProperty(field) && $scope.selected[field]) {
          $scope.selectedCount++;
        }
      }

      return $scope.selectedCount;

    };

    $scope.hasSelected = function() {
      return ($scope.selectedCount > 0);
    };

    $scope.hasErrors = function() {
      return ($scope.errors.length > 0);
    };

    $scope.done = function() {
      $scope.errors = [];


      if ($scope.hasSelected()) {
        $scope.success();
      }else{
        $scope.errors.push({
          message: 'You must select at least one field'
        });
      }
    };

    $scope.cancel = function () {
      $scope.errors = [];
      // Restore cached
      $scope.model = angular.copy($scope.cache);
      $scope.toggleSelected();

      $uibModalInstance.dismiss('cancel');
    };

    $scope.success = function () {
      var field,
          r = [];
      for (field in $scope.selected) {
        if ($scope.selected.hasOwnProperty(field) && $scope.selected[field]) {
          r.push(field);
        }
      }
      $uibModalInstance.close(r.join(','));
    };

    $scope.init();

  }]);